import { ReactNode } from "react";
import { ConnectedProps, connect } from "react-redux";

import { RightArrowIcon } from "@nens/ranalib";

import { AppDispatch } from "../App";
import { removeSelected as removeLeveeEditSelection } from "../state/existingLeveeEditsMenu";
import { removeSelected as removeRasterEditSelection } from "../state/existingRasterEditsMenu";
import { remove as removeProfileLine } from "../state/mapProfileLine";
import { remove as removeSelectedAsset } from "../state/selectedAsset";
import { removeXY } from "../state/selectedPoint";

import CollapsableSidebarStyles from "./CollapsableSidebar.module.css";
import menuStyles from "./Menu.module.css";

interface Props extends ConnectedProps<typeof connector> {
  titleElement: ReactNode;
  parent: string;
}

const RightMenuHeader: React.FC<Props> = (props) => {
  const {
    titleElement,
    parent,
    removeSelectedAsset,
    removeProfileLine,
    removeRasterEditSelection,
    removeLeveeEditSelection,
    removeXY,
  } = props;

  return (
    <div className={CollapsableSidebarStyles.HeaderContainer}>
      <h1 className={`${menuStyles.MenuHeader} ${menuStyles.RightMenuHeader}`}>{titleElement}</h1>
      <RightArrowIcon
        onClick={() => {
          if (parent === "ASSET") {
            removeSelectedAsset();
          } else if (parent === "PROFILE") {
            removeProfileLine();
          } else if (parent === "RASTEREDIT") {
            removeRasterEditSelection();
          } else if (parent === "LEVEEEDIT") {
            removeLeveeEditSelection();
          } else if (parent === "POINT") {
            removeXY();
          }
        }}
        role="button"
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  removeProfileLine: () => dispatch(removeProfileLine()),
  removeSelectedAsset: () => dispatch(removeSelectedAsset()),
  removeRasterEditSelection: () => dispatch(removeRasterEditSelection()),
  removeLeveeEditSelection: () => dispatch(removeLeveeEditSelection()),
  removeXY: () => dispatch(removeXY()),
});

const connector = connect(null, mapDispatchToProps);
export default connector(RightMenuHeader);
